<template>
  <div
    class="fade-in"
    :class=" size == 'no-grid' ? 'row-center-noGutter' : 'row-center-noGutter'"
  >
    <div
      class="byline-share-wrapper"
      :class="[
        size == 'narrow' ? 'col-10_md-8_lg-6': size == 'no-grid' ? '' : 'col-10_md-10_lg-10' ,
        (!author && !authordate) ? 'byline-share-wrapper--no-byline' : ''
      ]"
    >
      <bylineComponent
        :author="author"
        :authordate="authordate"
      />
      <shareComponent
        :title="title"
        :description="description"
        :align="align"
      />
    </div>
  </div>
</template>
<script>
import shareComponent from './subcomponents/shareComponent'
import bylineComponent from './subcomponents/bylineComponent'
import format from 'dateformat'

export default {
  name: 'BylineShareComponent',
  components: {
    shareComponent,
    bylineComponent,
  },
  props: {
    author: {
      type: String,
      default: ""
    },
    authordate: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    quote: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "narrow",
      validator (value) {
        return ["narrow", "wide", "no-grid"].includes(value)
      }
    },
    align: {
      type: String,
      default: "center",
      validator (value) {
        return ["center", "left"].includes(value)
      }
    }
  },
  methods: {
    isDate (authordate) {
      try {
         return format(new Date(authordate), "yyyy") > 1
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.byline-share-wrapper {
  margin-bottom: 2.5rem;
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;

  @include media-breakpoint-up(md) {
    margin-bottom: 3rem;
    grid-template-columns: auto 13rem;
  }

  &--no-byline {
    @include media-breakpoint-up(md) {
      justify-content: flex-end;
    }
  }
}
</style>
